/**
 * Switching every campaign group's Auto-send ON at once (19/10/2026): real
 * SMS, real money — the confirm says what this server really does, names
 * each group with the drafts it still has due today and its daily cap, and
 * that each group's stop-loss halts only that group while Kill stops all.
 * For Media Devoted | Created By Ciro Autiero
 */
import { FC } from 'react';
import type { DropGenGroupSendStatus } from '@trafficpulse/shared';

import { ConfirmDialog } from '@/components/ui';

import { type AutoSendMode, MODE_LINE, n } from '../autosend-fact';

const dueLine = (g: DropGenGroupSendStatus) => {
  const due = g.sendToday?.pendingDrops ?? 0;
  const cap = g.config.dailySmsCap ? ` · cap ${n(g.config.dailySmsCap)} SMS` : ' · no daily cap';
  return `${due > 0 ? `${n(due)} drafts due today (${n(g.sendToday?.pendingSms ?? 0)} SMS)` : 'nothing due today yet'}${cap}`;
};

export const AllGroupsConfirmDialog: FC<{
  open: boolean;
  groups: DropGenGroupSendStatus[];
  mode: AutoSendMode;
  /** 20/10/2026 — Auto-generate is off: switching on turns it on too. */
  autoGenerateOff?: boolean;
  busy: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}> = ({ open, groups, mode, autoGenerateOff = false, busy, onConfirm, onCancel }) => (
  <ConfirmDialog
    open={open}
    title={groups.length === 1 ? 'Turn Auto-send on?' : `Turn Auto-send on in all ${groups.length} campaign groups?`}
    confirmLabel={mode === 'real' ? 'Turn all on — real SMS' : mode === 'simulated' ? 'Turn all on — simulated' : 'Turn all on'}
    busy={busy}
    onConfirm={onConfirm}
    onCancel={onCancel}
    description={
      <div className="flex flex-col gap-3 text-sm">
        <p className={mode === 'real' ? '' : 'font-medium text-warning'}>{MODE_LINE[mode]}</p>
        <ul className="flex flex-col divide-y divide-border/60 rounded-md border border-border/60">
          {groups.map((g) => (
            <li key={g.masterId} className="flex items-center gap-2 px-3 py-2">
              <span className="h-2.5 w-2.5 shrink-0 rounded-full" style={{ backgroundColor: g.color }} aria-hidden />
              <span className="font-medium">{g.name}</span>
              <span className="ml-auto text-xs text-muted-foreground">{dueLine(g)}</span>
            </li>
          ))}
        </ul>
        {autoGenerateOff ? (
          <p className="text-xs font-medium">Auto-generate turns on too — auto-send only sends a day once it is laid out.</p>
        ) : null}
        <p className="text-xs text-muted-foreground">Each group’s stop-loss halts that group only. Kill stops every group’s next send.</p>
      </div>
    }
  />
);
